import { Button, Kbd } from '@patchbay/ui'
import { ChevronsUpDown, CornerDownLeft, Eye } from 'lucide-react'
import type * as React from 'react'

export function QueueKeyboardFooter({
  hasRows,
  atFirst,
  atLast,
  onPrevious,
  onNext,
  onFirst,
  onLast,
  onPeek,
  onOpen,
  onExpand,
  trailing,
}: {
  hasRows: boolean
  atFirst: boolean
  atLast: boolean
  onPrevious: () => void
  onNext: () => void
  onFirst: () => void
  onLast: () => void
  onPeek: () => void
  onOpen: () => void
  onExpand: () => void
  trailing?: React.ReactNode
}) {
  return (
    <div
      data-testid="queue-keyboard-footer"
      className="flex shrink-0 flex-wrap items-center gap-1 border-t border-border px-3 py-2 text-xs text-subtle"
    >
      <div data-keyboard-hints className="contents">
        <span className="sr-only">Up/down or J/K move; P peeks; Enter opens; Space shows the last turn.</span>
        <Button size="sm" variant="ghost" onClick={onPrevious} disabled={!hasRows || atFirst} title="Move up (↑ / K)">
          <Kbd keys="↑" /> <Kbd keys="k" /> Move up
        </Button>
        <Button size="sm" variant="ghost" onClick={onNext} disabled={!hasRows || atLast} title="Move down (↓ / J)">
          <Kbd keys="↓" /> <Kbd keys="j" /> Move down
        </Button>
        <Button size="sm" variant="ghost" onClick={onFirst} disabled={!hasRows || atFirst} title="Jump to first row (Home)">
          <Kbd keys="home" /> First
        </Button>
        <Button size="sm" variant="ghost" onClick={onLast} disabled={!hasRows || atLast} title="Jump to last row (End)">
          <Kbd keys="end" /> Last
        </Button>
        <Button size="sm" variant="ghost" onClick={onPeek} disabled={!hasRows} title="Peek without opening (P)">
          <Eye /> <Kbd keys="p" /> Peek
        </Button>
        <Button size="sm" variant="ghost" onClick={onOpen} disabled={!hasRows} title="Open case (Enter)">
          <CornerDownLeft /> <Kbd keys="enter" /> Open
        </Button>
        <Button size="sm" variant="ghost" onClick={onExpand} disabled={!hasRows} title="Last turn (Space)">
          <ChevronsUpDown /> <Kbd keys="space" /> Last turn
        </Button>
      </div>
      {trailing}
    </div>
  )
}
